export default __webpack_public_path__ + "static/media/imgDark4.c56ba9eb.png";